import BasicResource from '@/api/resource';

class ConfigResource extends BasicResource {

    constructor () {
        super('config');
    }

    update (data) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}`,
            data: data,
        });
    }

    getStrategies () {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/config/overwatch',
        });
    }

    updateStrategy (strategyName, data) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/config/overwatch/${strategyName}`,
            data: data,
        });
    }

    enableStrategy (strategy) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/config/overwatch/${strategy}/enable`,
        });
    }

    disableStrategy (strategy) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/config/overwatch/${strategy}/disable`,
        });
    }

    list () {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/config',
        });
    }

    currencies (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/config/currencies',
            params,
        });
    }

    currenciesEnable (data) {
        return this.client.request({
            method: 'put',
            path: '/upyield/v1/config/currencies/enable',
            data,
        });
    }

    currenciesDisable (data) {
        return this.client.request({
            method: 'put',
            path: '/upyield/v1/config/currencies/disable',
            data,
        });
    }

    customization () {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/config/customization',
        });
    }

    customize ({ section, item, file }) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/config/customization/${section}/${item}`,
            data: file,
            headers: { 'x-original-filename': file.name },
        });
    }

    listExternalIntegrations (params = {}) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/config/external-integrations',
            params,
        });
    }

    getSyncRules () {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/config/sync-options',
        });
    }

    theme () {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/config/theme',
        });
    }
}

export default new ConfigResource;

